import React, { ElementType, FC } from 'react';

import { Container, ContainerProps } from '@lglp/components';
import { useSelector } from 'react-redux';

import { RootState } from '../../../reducers';
import { getGlobalError } from '../../../selectors/errors';
import { ID } from '../Shortcuts';
import { ErrorState } from './ErrorState';
import { LoadingState } from './LoadingState';

export const Content: FC<ContentProps> = ({
  children,
  PageError = ErrorState,
  PageLoading = LoadingState,
  className,
  ...rest
}) => {
  const error = useSelector(
    (state: RootState) => getGlobalError(state) || state.main?.error
  );
  const loading = useSelector((state: RootState) => state.main?.loading);
  const document = useSelector((state: RootState) => state.main?.document);

  let contentChildren;
  if (error) {
    contentChildren = <PageError error={error} />;
  } else if (loading || !document) {
    contentChildren = <PageLoading />;
  } else {
    contentChildren = children;
  }

  return (
    <Container
      id={ID.MAIN}
      as="main"
      role="main"
      className={className}
      {...rest}
    >
      {contentChildren}
    </Container>
  );
};

export type ContentProps = ContainerProps & {
  PageError?: ElementType;
  PageLoading?: ElementType;
};
